import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CountryState {
  currencySymbol: string;
}

const initialState: CountryState = {
  currencySymbol: '',
};

const countrySlice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    setCurrencySymbol(state, action: PayloadAction<string>) {
      state.currencySymbol = action.payload;
    },
  },
});

export const { setCurrencySymbol } = countrySlice.actions;
export default countrySlice.reducer;
